/* eslint-disable no-unused-vars */
/* eslint-disable spaced-comment */
import { HttpService } from '../../services/HttpService';
import { getSecureBaseUrl } from '../../services/UrlMapperService';
import * as Constants from './Constants';
import { apiUrls } from '../../constants/apiUrl';
import { getCookie, getIntendType, getSession, isWHW, isWWM, viewport, isWHWP2 } from '../../components/common/Helpers/index';
import { postdataVal } from '../../components/common/Helpers/helperaction';

export const getDetailsFromApi = (data, homePhone, isApiPrefetch) => ({
  type: Constants.GET_DETAILS_FROM_API,
  data,
  homePhone,
  isApiPrefetch,
});

//updating contactInfo
export const contactInfoUpdte = (data, homePhoneAdded) => ({
  type: 'UPDATE_CONTACT_INFO',
  data,
  homePhoneAdded,
});

export const emailVaildationShippingAPI = (email, id) => ({
  type: Constants.EMAIL_VALIDATION_SHIPPING_API,
  data: { email, id },
});

export const accMainEmailShippingVerify = (data) => ({
  type: Constants.ACCOUNT_MAINTENENCE_SHIPPING_EMAIL_VERIFICATION,
  data,
});

export const selectedShippingOptionValue = (selectedValue) => ({
  type: 'SELECTED_SHIPPING_VALUE',
  selectedValue,
});
export const updateISPUContactInfo = (data, homePhoneAdded) => {
  let processingMTN = 'newLine1';
  const linesObj = {
    ispuContactInfo: {
      customerFirstName: data.firstName,
      customerLastName: data.lastName,
      customerEmailId: data.email,
      customerMobile: data.contactNumber.replace(/-/g, ''),
      enableEmailandTextNotification: data.checkBox ? 'Y' : 'N',
    },
    address: {
      firstName: data.firstName,
      lastName: data.lastName,
      addressLine1: '',
      addressLine2: '',
      city: '',
      zipCode: '',
      state: '',
      emailId: data.email,
      phoneNumber: data.contactNumber.replace(/-/g, ''),
    },
  };
  const lines = [
    {
      multiLineSeqNumber: 1,
      ispuContactInfo: linesObj.ispuContactInfo,
      address: linesObj.address,
    },
  ];

  if (homePhoneAdded) {
    processingMTN = '';
    lines.push({
      multiLineSeqNumber: 2,
      ispuContactInfo: linesObj.ispuContactInfo,
      address: linesObj.address,
    });
  }
  const postData = postdataVal(processingMTN, lines);
  return new Promise((resolve, reject) => {
    const apiURL = `${getSecureBaseUrl()}${apiUrls().updateISPUContactInfo}`;
    HttpService.post(apiURL, postData)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {});
  });
};

export const getDetails = () => {
  const postData = {
    optimizeSDD: 'Y',
  };
  // setCookie('XSRF-TOKEN', "5163ff28-f150-44e5-9d38-405b3b0d86ed");
  //const apiURL = `${getSecureBaseUrl()}${apiUrls().shippingDetailurl}`;
  // return HttpService.post(apiURL, postData, { headers });
  return new Promise((resolve, reject) => {
    const apiURL = `${getSecureBaseUrl()}${apiUrls().shippingDetailurl}`;
    HttpService.post(apiURL, postData)
      .then((response) => {
        resolve(response);
      })
      .catch(() => {});
  });
  // return HttpService.post(apiURL, postData);
};

// to get shippinGdetails from API

export const sddSlotsData = (data, dueTodayList) => ({
  type: Constants.GET_SLOTS_SDD,
  data,
  dueTodayList,
});

export const getslots = (data, dueTodayList) => {
  // debugger;
  const soridList = dueTodayList && dueTodayList.map((item) => item.sorId);
  const postData = {
    data: {
      sorIdList: soridList,
      address: {
        addressLine1: data[0].address.addressLine1,
        addressLine2: data[0].address.addressLine2,
        city: data[0].address.city,
        state: data[0].address.state,
        zipCode: data[0].address.zipCode,
      },
    },
  };
  return new Promise((resolve, reject) => {
    const apiURL = `${getSecureBaseUrl()}${apiUrls().getSddSlotDetails}`;
    HttpService.post(apiURL, postData)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {});
  });
};

// for fetchingMtns
export const fetchSMSEnabledDevices = (data) => ({
  type: Constants.GET_ENABLED_DEVICES,
  data,
});

export const clearDevices = (data) => ({
  type: 'CLEAR_DEVICES',
  data,
});

export const fetchDevices = (data) => {
  const reqt = {
    // acctNum: data,
    editType: 'shippingAddressChange',
  };

  return new Promise((resolve, reject) => {
    const apiURL = `${getSecureBaseUrl()}${apiUrls().getSMSEnabledDevices}`;
    HttpService.post(apiURL, reqt)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {});
  });
};

export const getZipDetailsFromApi = (data) => ({
  type: Constants.GET_ZIP_DETAILS_FROM_API,
  data,
});

export const getZipDetails = (value) => {
  // debugger;
  const postData = { data: { zipCode: value.data } };
  return new Promise((resolve) => {
    const apiURL = `${getSecureBaseUrl()}${apiUrls().zipMarketDetailsUrl}`;
    HttpService.post(apiURL, postData)
      .then((response) => {
        resolve(response);
      })
      .catch(() => {});
  });
};

export const securePinSendSMS = (data) => ({
  type: Constants.GET_SEND_SMS,
  data,
});

export const sendSms = (data) => {
  const reqt = {
    mtn: data,
  };

  return new Promise((resolve, reject) => {
    const apiURL = `${getSecureBaseUrl()}${apiUrls().sendSMS}`;
    HttpService.post(apiURL, reqt)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {});
  });
  // return HttpService.post(
  //   `${getSecureBaseUrl()}` + apiUrls().updateShippingOptions, postData
  // );
};

export const securePinValidateAuthCode = (MTN, otp) => ({
  type: Constants.CODE_VALIDATION,
  MTN,
  otp,
});

export const validateSMSSuccess = (data) => ({
  type: Constants.FETCH_SMS_DEVICES_SUCCESS,
  data,
});

export const pinValidation = (MTN, otp) => {
  const reqt = {
    mtn: MTN,
    otp,
  };

  return new Promise((resolve, reject) => {
    const apiURL = `${getSecureBaseUrl()}${apiUrls().validateOTP}`;
    HttpService.post(apiURL, reqt)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {});
  });
  // return HttpService.post(
  //   `${getSecureBaseUrl()}` + apiUrls().updateShippingOptions, postData
  // );
};

//securePinValidateAuthCode
export const saveSelectedOption = (data) => ({
  type: 'SAVE_SELECTED_OPTION',
  data,
});

export const buildShippingOptionsInput = (selectedShipping, selectedslots, sddOption, homePhoneAdded, isCheckoutAPI) => ({
  type: Constants.POST_SHIPPING_OPTION,
  selectedShipping,
  selectedslots,
  sddOption,
  homePhoneAdded,
  isCheckoutAPI,
});

export const updateShippingAddress = (data, homePhoneAdded) => ({
  type: Constants.UPDATE_SHIPPING_ADDRESS,
  data,
  homePhoneAdded,
});

export const updateAddress = (data, homePhoneAdded) => {
  let processingMTN = 'newLine1';
  const lines = [
    {
      multiLineSeqNumber: 1,
      address: {
        firstName: data?.firstName,
        lastName: data?.lastName,
        addressLine1: data.adress1,
        addressLine2: data.adress2,
        city: data.city,
        zipCode: data.zipCode,
        state: data.state,
        emailId: data?.emailId,
        phoneNumber: data?.phoneNumber,
      },
    },
  ];
  if (data.homePhoneAdded) {
    processingMTN = '';
    lines.push({
      multiLineSeqNumber: 2,
      address: {
        firstName: data?.firstName,
        lastName: data?.lastName,
        addressLine1: data.adress1,
        addressLine2: data.adress2,
        city: data.city,
        zipCode: data.zipCode,
        state: data.state,
        emailId: data?.emailId,
        phoneNumber: data?.phoneNumber,
      },
    });
  }
  const postData = {
    serviceHeader: {
      clientId: '',
      statusMsg: '',
      correlationId: '',
      sessionId: '',
      serviceName: 'SalesOrderPurchase',
      userId: '',
      statusCode: '0',
    },
    serviceBody: {
      serviceRequest: {
        context: {
          skipCheckoutCall: true,
          isFwaServiceAddress: data?.isFwaServiceAddress,
          customerInfo: {
            accountNumber: '',
            cartCreator: '',
            processingMTN,
          },
          cartInfo: {
            action: 'UPDATE',
            itemType: 'SHIPPINGADDRESS',
            userAction: 'updateShippingAddress',
            updateShippingContactInfo: false,
            intendType: `${getIntendType()}`,
            shipmentAddress: {
              lines,
            },
          },
          contextInfo: {
            callReason: 'SalesOrderPurchase',
            intent: isWHW() || isWWM() || isWHWP2() ? 'RedemptionAccessory' : `${getIntendType()}`,
            processStep: isWHW() || isWWM() || isWHWP2() ? 'PromoHub' : 'ShippingOptions',
            processAction: 'updateShippingAddress',
          },
        },
      },
    },
  };
  return new Promise((resolve, reject) => {
    const apiURL = `${getSecureBaseUrl()}${apiUrls().updateShippingAddress}`;
    HttpService.post(apiURL, postData)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {});
  });
};

export const postData = (data) => ({
  type: Constants.POST_SHIPPING_OPTION,
  data,
});

export const updateShippingOptions = (selectedShipping, selectedslots, sddOption, homePhoneAdded) => {
  let shipping = {};
  let processingMTN = 'newLine1';
  let flow;
  if (isWHW() || isWHWP2()) {
    processingMTN = viewport() === 'mfapp' ? getCookie('processingMTN') : getSession('processingMTN');
    flow = 'WHW_Redemption';
  }

  if (isWWM()) {
    processingMTN = viewport() === 'mfapp' ? getCookie('processingMTN') : getSession('processingMTN');
    flow = 'WWM_Redemption';
  }

  if (selectedShipping?.shippingOptionId === 'ISPU') {
    shipping = {
      depletionLocation: selectedShipping.depletionLocation,
      discription: selectedShipping.shippingDescription,
    };
  }
  if (selectedShipping?.shippingOptionId === 'SDD_SAMEDAY') {
    shipping = {
      shippingCode: sddOption?.shippingOptionId,
      shippingCost: sddOption?.shippingCost,
      shippingDescription: sddOption?.shippingDescription,
      locationSalesIdForSDD: sddOption?.locationSalesIdForSDD,
      depletionLocation: sddOption?.depletionLocationCode,
      fipsCode: '',
      sameDayDeliveryDetails: {
        deliverWindowKey: selectedslots?.id,
        deliverWindowStartTime: selectedslots?.startsAt,
        deliverWindowEndTime: selectedslots?.endsAt,
        userTimeZone: selectedslots?.timeZone,
        sddDeliveryDate: selectedslots?.endsAt,
      },
    };
  } else {
    shipping = {
      shippingCode: selectedShipping?.shippingOptionId,
      shippingCost: selectedShipping?.shippingCost,
      shippingDescription: selectedShipping?.shortDescription,
      deliveryDate: selectedShipping?.estimatedDeliveryDate,
      fipsCode: '',
    };
  }
  const shipmentInfo = [
    {
      multiLineSeqNumber: 1,
      shipping: { ...shipping },
    },
  ];
  if (homePhoneAdded) {
    processingMTN = '';
    shipmentInfo.push({
      multiLineSeqNumber: 2,
      shipping: { ...shipping },
    });
  }
  const postDataval = {
    serviceHeader: {
      clientId: 'VZW-ECOM',
      statusMsg: '',
      correlationId: '',
      sessionId: '',
      serviceName: 'SalesOrderPurchase',
      userId: '',
      statusCode: '',
    },
    flow,
    serviceBody: {
      serviceRequest: {
        context: {
          skipCheckoutCall: 'true',
          customerInfo: {
            accountNumber: '',
            cartCreator: '',
            processingMTN,
          },
          cartInfo: {
            action: 'UPDATE',
            itemType: 'SHIPPINGOPTION',
            intendType: `${getIntendType()}`,
            shipTogetherPref: true,
            shipmentInfo,
          },
          contextInfo: {
            callReason: 'SalesOrderPurchase',
            intent: isWHW() || isWWM() || isWHWP2() ? `RedemptionAccessory` : `${getIntendType()}`,
            processStep: isWHW() || isWWM() || isWHWP2() ? 'PromoHub' : 'ShippingOptions',
            processAction: 'updateShippingOptions',
          },
        },
      },
    },
  };
  return new Promise((resolve, reject) => {
    const apiURL = `${getSecureBaseUrl()}${apiUrls().updateShippingOptions}`;
    HttpService.post(apiURL, postDataval)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {});
  });
  // return HttpService.post(
  //   `${getSecureBaseUrl()}` + apiUrls().updateShippingOptions, postData
  // );
};

/*  Get ispu Store */
export const getISPUStores = (address, pageLoad) => ({
  type: 'GET_ISPU_STORE_LIST',
  data: address,
  pageLoad,
});

/* Update ISPU ship type */
export const updateISPUShippingOption = (data) => ({
  type: 'UPDATE_ISPU_SHIPPING',
  ...data,
});

export const resetStoreList = (data) => ({
  type: 'RESET_STORE_LIST',
  ...[],
});

export const getISPUStoresAPI = (data) => {
  const postDataval = data;
  const apiUrl = `${getSecureBaseUrl()}${apiUrls().checkISPUAvailability}`;
  return HttpService.post(apiUrl, postDataval);
};

// Update  shipping options
export const updateShippingOptionsAPI = (data, getCheckoutParams) => {
  // debugger;
  const { lines, purchasePath, shipTogetherPref } = data;
  const accountId = getSession('customerId');
  const mtn = getSession('mtn');
  let postDataval = {};
  let processingMTN = 'newLine1';
  let flow;
  if (isWHW() || isWHWP2() || isWWM()) {
    processingMTN = viewport() === 'mfapp' ? getCookie('processingMTN') : getSession('processingMTN');
    flow =  (isWHW() || isWHWP2()) ? 'WHW_Redemption' : 'WWM_Redemption';
  }
  postDataval = `${getIntendType()}`.includes('NSE')
    ? {
        serviceHeader: {
          clientId: 'VZW-ECOM',
          statusMsg: 'PEGA generated message',
          correlationId: '69a66ef4d7e344dfb2db299209ea8333',
          sessionId: '',
          serviceName: 'SalesOrderPurchase',
          userId: '',
          statusCode: '0',
        },
        flow,
        serviceBody: {
          serviceRequest: {
            context: {
              ...getCheckoutParams,
              skipCheckoutCall: true,
              customerInfo: {
                accountNumber: '',
                cartCreator: '',
                processingMTN,
                cradleFlowJourney: 'PromoHub',
              },
              cartInfo: {
                action: 'UPDATE',
                itemType: 'SHIPPINGOPTION',
                intendType: `${getIntendType()}`,
                shipTogetherPref: shipTogetherPref || false,
                shipmentInfo: lines,
              },
              contextInfo: {
                callReason: 'SalesOrderPurchase',
                intent: isWHW() || isWWM() || isWHWP2() ? `RedemptionAccessory` : `${getIntendType()}`,
                processStep: isWHW() || isWWM() || isWHWP2() ? 'PromoHub' : 'ShippingOptions',
                processAction: 'updateShippingOptions',
              },
            },
          },
        },
        expressCheckout: 'true',
      }
    : {
        serviceHeader: {
          clientId: 'VZW-ECOM',
          statusMsg: 'PEGA generated message',
          correlationId: '69a66ef4d7e344dfb2db299209ea8333',
          sessionId: '',
          serviceName: 'SalesOrderPurchase',
          userId: '',
          statusCode: '0',
        },
        flow,
        serviceBody: {
          serviceRequest: {
            context: {
              ...getCheckoutParams,
              skipCheckoutCall: true,
              customerInfo: {
                accountNumber: `${accountId}`,
                cartCreator: `${mtn}`,
                processingMTN,
                cradleFlowJourney: 'PromoHub',
              },
              cartInfo: {
                action: 'UPDATE',
                itemType: 'SHIPPINGOPTION',
                intendType: `${getIntendType()}`,
                shipTogetherPref: shipTogetherPref || false,
                shipmentInfo: lines,
              },
              contextInfo: {
                callReason: 'SalesOrderPurchase',
                intent: isWHW() || isWWM() || isWHWP2() ? `RedemptionAccessory` : `${getIntendType()}`,
                processStep: isWHW() || isWWM() || isWHWP2() ? 'PromoHub' : 'ShippingOptions',
                processAction: 'updateShippingOptions',
              },
            },
          },
        },
        expressCheckout: 'true',
      };
  return HttpService.post(`${getSecureBaseUrl()}${apiUrls().updateShippingOptions}`, postDataval);
};

export const toggleContactInfo = (data) => ({
  type: 'TOGGLE_CONTACT_SUCCESS',
  data,
});

export const gettingShippingOptionHeader = (data) => ({
  type: Constants.GET_SHIPPING_OPTION_HEADER,
  value: data,
});

export const clearInvalidAdressFlag = () => ({
  type: 'CLEAR_INVALID_RESPONSE',
});

export const updateStoreListValue = (value) => ({
  type: 'ISPU_STORES_UPDATED',
  response: value,
});

export const shippingAddress2unitItems = (data) => ({
  type: 'SHIPPING_ADDRESS2_UNIT_ITEMS',
  data,
});

export const shippingAddress2unitArray = (data) => ({
  type: 'SHIPPING_ADDRESS2_UNIT_ARRAY',
  data,
});

export const shippingAddressEdited = (data) => ({
  type: 'SHIPPING_ADDRESS_CHANGE',
  data,
});

export const setShippingAddressRadio = (data) => ({
  type: 'SHIPPING_ADDRESS_RADIO_SELECTED',
  data,
});

export const changeDivToPickUp = (data) => ({
  type: 'SHOW_PICKUP_INFO',
  data,
});
